import React from 'react';
import { Col, Row } from 'reactstrap';

import PageCard from '../PageCard';

export const withSidecardWrapper = ({ SideComponent, texts = {}, header, ...extra }) => (WrapperComponent) => (props) => {
  const title = (texts.title && typeof texts.title === 'function') ? texts.title(props) : texts.title;
  const subtitle = (texts.subtitle && typeof texts.subtitle === 'function') ? texts.subtitle(props) : texts.subtitle;

  return (
    <React.Fragment>
      {header}

      <PageCard className="PaymentForm SidecardWrapper">
        <Row className="SidecardWrapper__container">
          <Col sm={12} md={12} lg={6} className="SidecardWrapper__SideComponent">
            <SideComponent {...extra.sideProps} {...props} />
          </Col>

          <Col sm={12} md={12} lg={6} className="SidecardWrapper__WrapperComponent">
            {title && (
              <span className="PaymentForm__title SidecardWrapper__WrapperComponent__title">{title}</span>
            )}

            {subtitle && (
              <span className="PaymentForm__subtitle SidecardWrapper__WrapperComponent__subtitle">{subtitle}</span>
            )}

            <WrapperComponent {...props} prueba="test" />
          </Col>
        </Row>
      </PageCard>
    </React.Fragment>

  );
}
